$(document).ready(function() {
  // Cuando se hace hover sobre el <summary>
  $('#HeaderMenu-shop').on('mouseenter', function() {
    $('#Details-HeaderMenu-1').attr('open', true);
    $(this).attr('aria-expanded', true);
  });

  // Cuando el mouse sale del menú completo
  $('#Details-HeaderMenu-1').on('mouseleave', function() {
    $('#Details-HeaderMenu-1').removeAttr('open');
    $('#HeaderMenu-shop').attr('aria-expanded', false);
  });

  // Cuando se hace hover sobre el <summary>
  $('#HeaderMenu-lookbook').on('mouseenter', function() {
    $('#Details-HeaderMenu-2').attr('open', true);
    $(this).attr('aria-expanded', true);
  });

  // Cuando el mouse sale del menú completo
  $('#Details-HeaderMenu-2').on('mouseleave', function() {
    $('#Details-HeaderMenu-2').removeAttr('open');
    $('#HeaderMenu-lookbook').attr('aria-expanded', false);
  });
});